module.exports = __webpack_public_path__ + "5d5d9eefa31e5e13a6610d9fa7a283bb.svg";